import React, { useContext } from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { StoreContext } from "../../context/StoreContext";

import AdminInsights from "../AdminInsights/AdminInsights";
import Dashboard from "../Dashboard/Dashboard";
import Applications from "../Applications/Applications";
import Downloads from "../Downloads/Downloads";
import Assessments from "../Assessments/Assessments";
import Login from "../Login/Login";

import AdminNav from "../../pages/AdminNav/AdminNav";
import InfoSubmissions from "../InfoSubmissions/InfoSubmissions";

function AdminApp() {

  const {
    isAuthenticated,
    admin,
    loading,
    login,
  } = useContext(StoreContext);

  // Loading Screen
  if (loading) {
    return (
      <div className="loading-screen">
        Loading...
      </div>
    );
  }

  // Login Page
  if (!isAuthenticated) {
    return <Login onLogin={login} />;
  }

  return (
    <div className="admin-app">

      {/* Admin Navbar */}
      <AdminNav />

      {/* Admin Content */}
      <div className="admin-content">

        <Routes>

          {/* Default Redirect */}
          <Route
            path="/"
            element={<Navigate to="dashboard" />}
          />

          {/* Dashboard */}
          <Route
            path="dashboard"
            element={<Dashboard admin={admin} />}
          />

          {/* Insights */}
          <Route
            path="insights"
            element={<AdminInsights />}
          />

          {/* Applications */}
          <Route
            path="applications"
            element={<Applications />}
          />

          {/* Downloads */}
          <Route
            path="downloads"
            element={<Downloads />}
          />

          {/* Assessments */}
          <Route
            path="assessment"
            element={<Assessments />}
          />

          <Route
          path="/contact-forms"
          element = {<InfoSubmissions/>}
          />

        </Routes>

      </div>
    </div>
  );
}

export default AdminApp;